export enum UserStatus {
  Accepted = 'ACCEPTED',
  Invited = 'INVITED',
}
